import React, { useState, useMemo, useCallback } from 'react';
import Accordion from 'components/Accordion';
import buildAccordionClickFunction from 'helper/buildAccordionClickFunction';
import Snackbar from 'components/DesignSystem/Snackbar';
import Searcher from 'components/DesignSystem/Searcher';
import RadioButton from 'components/DesignSystem/RadioButton';
import useGroupedLocations from 'hooks/Meteorology/Agro/TrackingForecast/DetailedView/useGroupedLocations';

export default function Groups() {
  const { groups, selectedGroup, setGroup } = useGroupedLocations();
  const [search, setSearch] = useState('');

  const closeAccordion = useMemo(() => buildAccordionClickFunction('groups-accordion'), []);
  const setGroupAndClose = useCallback((newGroup : number) => {
    setGroup(newGroup);
    closeAccordion();
  }, [setGroup, closeAccordion]);
  const pattern = new RegExp(search.split('').join('.*'), 'i');

  return (
    <Accordion.Item eventKey="groups" id="groups-accordion">
      <Accordion.Header>Grupo</Accordion.Header>
      <Accordion.Body>
        <Searcher value={search} onChange={(e) => setSearch(e.target.value)} />
        {groups.length === 0 && (
          <Snackbar className="mt-2">
            Nenhum grupo disponível
          </Snackbar>
        )}
        {groups.filter((group) => pattern.test(group.name)).map((group) => (
          <RadioButton
            key={group.id}
            label={group.name}
            checked={group.id === selectedGroup?.id}
            onChange={() => setGroupAndClose(group.id)}
            className="my-2"
          />
        ))}
      </Accordion.Body>
    </Accordion.Item>
  );
}
